import * as React from "react";
import { useWindowDimensions } from "react-native";
import { createDrawerNavigator } from "@react-navigation/drawer";
import { drawerItemsMain } from "./ChinaTrackerDrawerItemsMain ";
import CustomDrawerContent from "../../../components/custom/CustomDrawerContent";
import ChinaTrackerScreen from "../../../screens/ChinaTracker/ChinaTrackerScreen";
import ChinaTrackerDetailsReport from "../../../screens/ChinaTracker/partials/ChinaTrackerDetailsReport";
import { useTranslation } from "../../../utils/useTranslation";

const Drawer = createDrawerNavigator();

export default function ChinaTrackerDrawerNavigator() {
  const dimensions = useWindowDimensions();
  const { t } = useTranslation();

  return (
    <Drawer.Navigator
      screenOptions={{
        drawerStyle: {
          width: 200,
        },
        drawerLabelStyle: {
          fontSize: 12,
          textTransform: "none",
        },
        drawerType: dimensions.width >= 768 ? "front" : "front", //'permanent' : 'front',
      }}
      drawerContent={(props) => (
        <CustomDrawerContent drawerItems={drawerItemsMain} {...props} />
      )}
    >
      <Drawer.Screen
        options={{
          drawerLabel: "ChinaTracker",
          title: "China Tracker",
        }}
        name="ChinaTrackerReport"
        component={ChinaTrackerScreen}
      />

      <Drawer.Screen
        options={{
          drawerLabel: "ChinaTrackerDetailsReport",
          title: t("chinaOrderTracker"),
        }}
        name="ChinaTrackerDetailsReport"
        component={ChinaTrackerDetailsReport}
      />
    </Drawer.Navigator>
  );
}
